var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"flat":"","rounded":""}},[_c('v-card-text',[_vm._v("There's no page for Test Type right now.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }